import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';
import { CircularProgress, Typography, useTheme } from '@mui/material';
import Box from '@mui/material/Box';

const CircularIndicator = ({ label, data, size = 80, thickness = 4, ...props }) => {
    const value = data?.porcentaje ?? data;
    const minutosJugados = data?.minutosJugados ?? 0;
    const totalMinutos = data?.totalMinutos ?? 0;

    const theme = useTheme();

    const getColor = (value) => {
        if (value > 80) return '#1976D2'; // Azul
        if (value > 60) return '#388E3C'; // Verde
        if (value > 40) return '#F57C00'; // Naranja
        return '#D32F2F'; // Rojo
    };

    return (
        <Box className="player-circular-indicator" {...props}>
            <Box className="player-circular-progress-container">
                <CircularProgress
                    variant="determinate"
                    value={value}
                    size={size}
                    thickness={thickness}
                    className="player-circular-progress"
                    sx={{ color: getColor(value) }}
                />
                <Typography variant="h3" className="player-circular-value">
                    {value}%
                </Typography>
            </Box>
            <Typography fontSize={12} mb={0} variant="h4">
                {minutosJugados} / {totalMinutos}
            </Typography>
            <Typography fontSize={10} variant="h5">
                {label}
            </Typography>
        </Box>
    );
};

const MinutesActionsMatchesPlayerComponent = ({ partidos }) => {
    const theme = useTheme();

    const calcularPorcentaje = (cantidadPartidos) => {
        // Obtener los minutos jugados en los últimos "cantidadPartidos"
        const minutosJugados = partidos
            ?.slice(0, cantidadPartidos)
            ?.reduce((total, partido) => total + Number(partido?.minutes ?? 0), 0);
        // Calcular el porcentaje en base a la cantidad total de minutos posibles (cantidadPartidos * 90)
        return {
            porcentaje: ((minutosJugados / (cantidadPartidos * 90)) * 100).toFixed(0),
            minutosJugados: minutosJugados,
            totalMinutos: cantidadPartidos * 90,
        }; // Redondeado a 1 decimal
    };

    return (
        <CustomSectionWrapper color="accent2" title="Porcentaje de minutos disputados">
            <Box style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
                <CircularIndicator label="Último partido" data={calcularPorcentaje(1)} size={50} />
                <CircularIndicator
                    label="Últimos 3 partidos"
                    data={calcularPorcentaje(3)}
                    size={50}
                    borderLeft={`1px solid ${theme.palette.border.main}`}
                />
                <CircularIndicator
                    label="Últimos 5 partidos"
                    data={calcularPorcentaje(5)}
                    size={50}
                    borderLeft={`1px solid ${theme.palette.border.main}`}
                />
                <CircularIndicator
                    label="Últimos 10 partidos"
                    data={calcularPorcentaje(10)}
                    size={50}
                    borderLeft={`1px solid ${theme.palette.border.main}`}
                />
            </Box>
        </CustomSectionWrapper>
    );
};

export default MinutesActionsMatchesPlayerComponent;
